'use strict';

const globals = {
	breakpoint: 1025
};

export default globals;